// extracted by mini-css-extract-plugin
export default {"nativeCheckbox":"checkbox_nativeCheckbox__+jtz3","checkbox":"checkbox_checkbox__dHqTJ"};